module.exports = __webpack_public_path__ + "static/media/helpdesk-icon.6ebddc1a.png";